export default __webpack_public_path__ + "static/prostatizal-feature-1a575adde3f05fb5aa02c5a129a31a09.jpg";